import {
  forwardRef,
  type InputHTMLAttributes,
  type ReactNode,
  type TextareaHTMLAttributes,
} from "react";

export interface FieldShellProps {
  label?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}

/** Labeled form-row wrapper (design §4.16). */
export function FieldShell({ label, hint, children, className }: FieldShellProps) {
  return (
    <div className={`form-row${className ? ` ${className}` : ""}`}>
      {label && <label className="field-label">{label}</label>}
      {children}
      {hint && <p className="field-hint">{hint}</p>}
    </div>
  );
}

export type TextFieldProps = InputHTMLAttributes<HTMLInputElement>;

/** Single-line text input wrapped in the `.field` shell. */
export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  function TextField({ className, ...props }, ref) {
    return (
      <div className={`field${className ? ` ${className}` : ""}`}>
        <input ref={ref} {...props} />
      </div>
    );
  },
);

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/** Multi-line text input wrapped in the `.field field-area` shell. */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  function TextArea({ className, rows = 3, ...props }, ref) {
    return (
      <div className={`field field-area${className ? ` ${className}` : ""}`}>
        <textarea ref={ref} rows={rows} {...props} />
      </div>
    );
  },
);
